// subjects/redux/questionBankThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import API_BASE_URL from "../../config";
import { setEditingQuestion } from "./questionBankSlice";
export const fetchQuestionTypes = createAsyncThunk(
  "questionBank/fetchQuestionTypes",
  async ({ classId, subjectId }, { rejectWithValue }) => {
    try {
      const res = await fetch(
        `${API_BASE_URL}/classes/by-class/${classId}/subject/${subjectId}`
      );

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(
          errorData.message || "Failed to fetch question types"
        );
      }

      const data = await res.json();

      // ✅ Confirm data is array
      if (!Array.isArray(data)) {
        return rejectWithValue("Expected array but got non-array data");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const addQuestionThunk = createAsyncThunk(
  "questionBank/addQuestion",
  async (
    { questionData, classId, subjectId, chapterId },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetch(`${API_BASE_URL}/questions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...questionData,
          class_id: parseInt(classId),
          subject_id: parseInt(subjectId),
          chapter_id: parseInt(chapterId),
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || "Failed to add question");
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Edit Question
export const editQuestionThunk = createAsyncThunk(
  "questionBank/editQuestion",
  async (
    { questionPayload, classId, subjectId, chapterId, userId },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/questions/${questionPayload.question_id}`,

        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...questionPayload,
            class_id: parseInt(classId),
            subject_id: parseInt(subjectId),
            chapter_id: parseInt(chapterId),
            updated_by: userId,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || "Failed to edit question");
      }

      dispatch(setEditingQuestion(null));
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//To fetch question as per the filters
export const fetchQuestionsThunk = createAsyncThunk(
  "questionBank/fetchQuestions",
  async (
    { classId, subjectId, sectionId, chapterId, questionTypeId, page, limit },
    { rejectWithValue }
  ) => {
    try {
      const queryParams = new URLSearchParams();
      if (classId) queryParams.append("class_id", classId);
      if (subjectId) queryParams.append("subject_id", subjectId);
      if (sectionId) queryParams.append("section_id", sectionId);
      if (chapterId) queryParams.append("chapter_id", chapterId);
      if (questionTypeId) {
        queryParams.append("questionType", questionTypeId);
      }
      if (page) {
        queryParams.append("page", page);
      }else {
        queryParams.append("page", 1);
      }
      if (limit) {
        queryParams.append("limit", limit);
      }else {
        queryParams.append("limit", 10);
      }

      const response = await fetch(
        `${API_BASE_URL}/questions?${queryParams.toString()}`
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch questions");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//For variants
export const fetchQuestionVariantsThunk = createAsyncThunk(
  "questionBank/fetchVariants",
  async ({ parentQuestionId }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/questions/${parentQuestionId}`
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch questions.");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const editVariantThunk = createAsyncThunk(
  "questionBank/editVariant",
  async ({ questionPayload }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/questions/${questionPayload.question_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...questionPayload,
            //  created_by: questionPayload.created_by || userId,
            //  updated_by: questionPayload.updated_by || userId,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || "Failed to update variant");
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
